<template>
    <div class="magazine-page-check"
         :id="`page-order-${pageOrder}`">
        <div :class="lowresLoading ? 'lowres loading' : 'lowres'">
            <div class="page-order">
                {{pageOrder}}
            </div>
            <img class="lowres-image"
                 :src="lowresImage"
                 alt=""
                 v-if="!lowresLoading">
            <div class="image-loading"
                 v-else>
            </div>
        </div>
        <div :class="highresLoading ? 'highres loading' : 'highres'">
            <img class="highres-image"
                 :src="highresImage"
                 alt=""
                 v-if="!highresLoading">
            <div class="image-loading"
                 >
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "design2021-magazine-check-page-component",
        props: {
            highresImage: {
                type: String,
                required: true,
            },
            lowresImage: {
                type: String,
                required: true,
            },
            pageOrder: {
                type: Number,
                required: true,
            },
            pageIndex: {
                type: Number,
                required: true,
            },
            magazineType: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                highresLoading: true,
                lowresLoading: true,
            }
        },

        mounted(){
            if(this.highresImage !== ''){
                this.highresLoading = false;
            }

            if(this.lowresImage !== ''){
                this.lowresLoading = false;
            }
        },
    }
</script>

<style scoped lang="scss">
    @keyframes shine {
        to {
            background-position-x: -200%;
        }
    }

    .magazine-page-check {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        column-gap: $grid-gutter-width;
        row-gap: map-get($grid-gutter-spacing, 'ten');

        &:not(:last-child){
            margin-bottom: map-get($grid-gutter-spacing, 'ten');
        }
    }

    .lowres,
    .highres {
        position: relative;

        &.loading {
            align-self: stretch;

            .image-loading {
                background: #eee;
                background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
                background-size: 200% 100%;
                animation: 1.5s shine linear infinite;
                min-height: 250px;
                height: 100%;
            }
        }

        img {
            width: 100%;
            height: calc(100vh - 50px);
            object-fit: contain;
            object-position: center;
        }
    }

    .page-order {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 0;
        left: 0;
        width: 30px;
        height: 30px;
        background-color: $primary;
        color: $white;
    }

    @media(min-width: map-get($grid-breakpoints, 'lg')){
        .magazine-page-check {
            flex-direction: row;
        }

        .lowres,
        .highres {
            width: calc(50% - 15px);
        }
    }

</style>
